// Login API Endpoint
export const POST_ADMIN_LOGIN = "login/adminlogin";
export const FETCH_USER_PROFILE = "login/userprofile";
export const GENERATE_OTP_FORGOT_PASSWORD = "login/forgotpassword";
export const VERIFY_OTP_FORGOT_PASSWORD = "login/verifyemailotp";
export const RESET_PASSWORD = "login/resetpassword";
export const SEND_MOBILE_OTP = "login/sendotp";
export const VERIFY_MOBILE_OTP = "login/verifyotp";

// Package Listing API's
export const GET_PACKAGE_LISTING = "jobmanagement/joblist";
export const GET_PACKAGE_BY_ID = "jobmanagement/job";
export const GET_PACKAGE_BY_ID_STATUS = "jobmanagement/jobstatus";
export const DELETE_PACKAGE_BY_ID = "jobmanagement/deletejob";
export const GET_PACKAGE_LISTING_COUNT = "jobmanagement/alljobcount";

// Package CRUD API's
export const CRUD_PACKAGE = "jobmanagement/job";

// Users List API Endpoint
export const GET_USERS_LIST = "jobmanagement/userlist";
export const GET_DELIVERY_JOB_COUNT_USER = "jobmanagement/deliveryjobcount";
export const GET_REQUESTOR_JOB_COUNT_USER = "jobmanagement/requestedjobcount";

// DropDown API's
export const DROPDOWN_STATE = "jobmanagement/state";
export const DROPDOWN_CITY = "jobmanagement/city";
export const DROPDOWN_ZIPCODE = "jobmanagement/zipCode";

// Google Api
export const GOOGLE_API_KEY = "AIzaSyDZg_6V47XwL0kJNpuBKLWnsKye9rlyhho";
export const GOOGLE_API_KEY_CREATE_PACK = "AIzaSyCq6cNynYfPCHORdAr4JWfHqmyfl6dsBAE";

// Notifications API
export const GET_NOTIFICATIONS_LIST = "notification/notificationsList";
export const PUT_NOTIFICATIONS_STATUS = "notification/notificationReadStatus";
export const GET_UNREAD_NOTIFICATIONS = "notification/CheckForUnreadNotifications";
export const SAVE_FIREBASE_TOKEN = "login/savefirebasetoken";
export const LOGOUT_FIREBASE_TOKEN = "login/logout";

